import React, { useMemo } from 'react';
import styles from './TransactionsStats.module.scss';
import CountUp from '../UI/CountUp';

const formatMoney = (n) => Number(n || 0).toLocaleString('ru-RU');

export default function TransactionsStats({ items = [] }) {
  const stats = useMemo(() => {
    let income = 0;
    let expense = 0;

    for (const t of items) {
      const amt = Number(t.amount) || 0;
      if (t.type === 'income') income += amt;
      if (t.type === 'expense') expense += amt;
    }

    return {
      income,
      expense,
      total: items.length,
    };
  }, [items]);

  return (
    <div className={styles.stats}>
      <div className={styles.stats__inner}>
        <div className={styles.stats__blocks}>
          <div className={`${styles.stats__block} ${styles.income}`}>
            <h4 className={styles.stats__title}>Доход:</h4>
            <h4 className={styles.stats__value}>
              <CountUp
                from={0}
                to={stats.income}
                separator=' '
                duration={0.5}
              />{' '}
              ₽
            </h4>
          </div>

          <div className={`${styles.stats__block} ${styles.expense}`}>
            <h4 className={styles.stats__title}>Расход:</h4>
            <h4 className={styles.stats__value}>
              <CountUp
                from={0}
                to={stats.expense}
                separator=' '
                duration={0.5}
              />{' '}
              ₽
            </h4>
          </div>

          <div className={`${styles.stats__block} ${styles.total}`}>
            <h4 className={styles.stats__title}>Транзакций:</h4>
            <h4 className={styles.stats__value}>
              <CountUp from={0} to={stats.total} separator=' ' duration={0.5} />
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}
